var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div id=\"apptemplate-delete\" style=\"overflow: auto; width: auto; height: auto;\" class=\"popup popup-delete\"><div ng-style=\"{'background': theme_color }\" class=\"head\"><h2>Delete Form</h2></div><div class=\"container\"><p>Are you sure you want to delete this form?</p><div class=\"buttons\"><a ng-click=\"$dismiss()\" class=\"cancel view-delete-button\">Cancel</a><a ng-click=\"remove_apptemp(current_id)\" class=\"delete delete-item-button\">Delete</a><div class=\"cf\"></div></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/quickformsTable/removeModal.jade
// module id = 458
// module chunks = 0